const getSectionId = (section) => section?.id?.replace('shopify-section-', '');

const animateRemoval = async (card) => {
  if (!card || !card.animate) return;

  await card.animate(
    [
      {opacity: 1, transform: 'translateY(0)'},
      {opacity: 0, transform: 'translateY(-6px)'},
    ],
    {duration: 180, easing: 'ease-out', fill: 'forwards'},
  ).finished;
};

const replaceCartPageSection = (section, html) => {
  if (!section || !html) return false;

  const documentFragment = new DOMParser().parseFromString(html, 'text/html');
  const replacement = documentFragment.getElementById(section.id);

  if (!replacement) return false;

  section.replaceWith(replacement);
  return true;
};

document.addEventListener('submit', async (event) => {
  const form = event.target.closest?.('[data-kit-remove-form]');
  if (!form) return;

  event.preventDefault();

  if (form.dataset.pending === 'true') return;

  const card = form.closest('.kit-cart-card');
  const buttons = card?.querySelectorAll('.kit-cart-card__remove-button') ?? [];
  const pageSection = form.closest('.shopify-section');
  const pageSectionId = getSectionId(pageSection);
  const isDrawer = Boolean(form.closest('cart-drawer'));
  const sections = [];

  document.documentElement.dispatchEvent(
    new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: {sections},
    }),
  );

  if (!isDrawer && pageSectionId) sections.push(pageSectionId);

  const requestedSections = [...new Set(sections)];
  const updates = Object.fromEntries(
    [...new FormData(form).entries()]
      .filter(([name]) => name.startsWith('updates['))
      .map(([name, quantity]) => [name.slice(8, -1), Number(quantity)]),
  );

  form.dataset.pending = 'true';
  card?.setAttribute('aria-busy', 'true');
  buttons.forEach((button) => {
    button.disabled = true;
  });

  try {
    const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        updates,
        sections: requestedSections,
        sections_url: window.location.pathname,
      }),
    });

    if (!response.ok) throw new Error('Could not remove Kitflow kit');

    const cart = await response.json();

    if (!isDrawer && !replaceCartPageSection(pageSection, cart.sections?.[pageSectionId])) {
      throw new Error('Could not refresh cart page section');
    }

    const removalAnimation = animateRemoval(card);

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: {baseEvent: 'kit:remove', cart},
      }),
    );

    await removalAnimation;
    card?.remove();
  } catch (error) {
    console.error(error);
    form.submit();
  }
});
